import { keyframes } from '@emotion/react';
import { Theme } from '@mui/material';

const shimmer = keyframes`
  0% { background-position: 150% 0; }
  100% { background-position: -150% 0; }
`;

interface ShimmerTextStops {
  start: number;
  middle: number;
  end: number;
}

export const getShimmerTextSx = (theme: Theme, stops: ShimmerTextStops) => ({
  background: `linear-gradient(90deg, ${theme.palette.text.secondary} ${stops.start}%, ${theme.palette.text.primary} ${stops.middle}%, ${theme.palette.text.secondary} ${stops.end}%)`,
  backgroundSize: '250% 100%',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
  WebkitTextFillColor: 'transparent',
  animation: `${shimmer} 3s ease-in-out infinite`,
});
